import { jsx as _jsx } from "react/jsx-runtime";
export default function LandingParagraph(props) {
    return (_jsx("p", { className: `text-2xl font-light leading-8 text-day-mode-text-tertiary ${props.className}`, children: props.children }));
}
